import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserHistoryService {
  loadMoreItems: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  loadMoreItems$ = this.loadMoreItems.asObservable();
}
